import { render } from "./CompaniesServices.vue?vue&type=template&id=7efaf950&scoped=true&ts=true"
import script from "./CompaniesServices.vue?vue&type=script&lang=ts"
export * from "./CompaniesServices.vue?vue&type=script&lang=ts"

import "./CompaniesServices.vue?vue&type=style&index=0&id=7efaf950&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efaf950"]])

export default __exports__